module.exports = __webpack_public_path__ + "img/banner-1-m.4999af6c.jpg";